import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlycaUiSplitterComponent } from '../splitter.component';

@Component({
  selector: 'plyca-ui-splitter-demo',
  templateUrl: './splitter-demo.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiSplitterComponent]
})
export class PlycaUiSplitterDemoComponent {}
